// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  dateFormat: 'dd-MM-yyyy',
  //champsApiUrl: 'https://angualrapp.azurewebsites.net/capi/api',
  //champsApiUrl: 'https://champsqa.azurewebsites.net/champsapi/api',
  //optimizerUrl: 'https://champsoptimizer.azurewebsites.net/api',
  champsApiUrl: 'https://champsqa.ko.com/champsapi/api/',
  optimizerUrl: 'https://tccc-edge-cpd-qa-02.azureedge.net//api/',
  //authUrl: 'https://ief.ko.com/.auth/me'
  authUrl: 'assets/resource/temp-auth.json'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
